import { useSnapshot } from 'valtio'
import Pie from '@/components/Icons/Pie'
import { Link } from '@/lib/navigation'
import { state } from '@/lib/state'
import { cn } from '@/lib/utils'
import type { Quadrant } from '../../../../types'
import styles from './QuadrantLink.module.css'

interface QuadrantLinkProps {
  quadrant: Quadrant
  label?: string
  className?: string
}

export function QuadrantLink({
  quadrant,
  label: propLabel,
  className
}: QuadrantLinkProps) {
  const { radarConfig } = useSnapshot(state)
  const labels = radarConfig?.labels || {}
  const label = propLabel || labels.zoomIn

  return (
    <Link
      href={`${quadrant.id}`}
      className={cn(styles.link, className)}
      data-testid={`quadrant-link-${quadrant.id}`}
    >
      <Pie
        className={styles.icon}
        data-testid={`quadrant-link-icon-${quadrant.id}`}
      />
      <span
        className={styles.label}
        data-testid={`quadrant-link-label-${quadrant.id}`}
      >
        {label}
      </span>
    </Link>
  )
}
